import { useToggleState } from '@cian/react-utils';
import { useDeviceType } from '@cian/ui-kit';
import { useCallback, useState } from 'react';
import { AboutServiceBanner } from 'shared/components/AboutServiceBanner';
import { ABOUT_SERVICE } from 'shared/constants/aboutService';
import { TAboutService } from 'shared/types/aboutService';

export const AboutServiceBannerContainer: React.FC = () => {
  const device = useDeviceType();

  const [activeItem, setActiveItem] = useState<TAboutService>(ABOUT_SERVICE[0]);

  const { state: visibleNotice, toggle: toggleVisibleNotice } = useToggleState(false);

  const handleActiveItem = useCallback(
    (newValue: TAboutService) => {
      if (visibleNotice) {
        toggleVisibleNotice();
      }
      setActiveItem(newValue);
    },
    [toggleVisibleNotice, visibleNotice],
  );

  return (
    <AboutServiceBanner
      device={device}
      onChangeActiveNotice={toggleVisibleNotice}
      activeItem={activeItem}
      onChangeActiveItem={handleActiveItem}
      activeNotice={visibleNotice}
    />
  );
};
